import axios from './axios';
import { Getter } from './batch';

export declare interface Request {
    q?: string;
    max?: number;
    p?: number;
    sort?: string;
    data?: string;
    extra?: string;
    colStats?: string;
}

export declare interface Response {
    nextPage: boolean;
    returnedFields: string[];
}

export function Getters<T extends { id?: unknown }, H extends Response>(path: string, handler: (resp: H) => T[]) {
    type I = NonNullable<T['id']>;

    const promises = new Map<string, Promise<Map<I, T>>>();

    const getAll = (params?: Request, getter: Getter = axios): Promise<Map<I, T>> => {
        const j = JSON.stringify(params);
        let p = promises.get(j);

        if (!p) {
            p = getter.get<H>(path, { params }).then(resp => {
                const m = new Map<I, T>();
                const values = handler(resp.data);
                for (const v of values) {
                    if (!v.id) {
                        continue;
                    }
                    m.set(v.id as NonNullable<T['id']>, v);
                }

                return m;
            });
            promises.set(j, p);

            // delete our promise after 2 seconds
            void p.then(() => setTimeout(() => promises.delete(j), 2000));
        }

        return p;
    };

    const get = (id?: I, params?: Request, getter: Getter = axios): Promise<T | undefined> => {
        if (id === undefined) {
            return Promise.resolve(undefined);
        }
        return getAll(params, getter).then(m => m.get(id));
    };

    return { getAll, get };
}